import {useEffect, useState,} from "react"
import Menu from "../ui/menu";
import HomeMain from "../features/homeMain";
import Footer from "../ui/footer";
const Home = ()=>{
    const [intro, setIntro] = useState(true)
    useEffect(()=>{
        const timer = setTimeout(() => {
            setIntro(false);

        },2000)
        return () => clearTimeout(timer)
    }, [])


    return (
        <>
            {
                intro? <>
                <div className="intro ">
                    <p className="logo ">@</p>
                </div>
            </>:<>

            <Menu />
            <HomeMain />
            <Footer />
            </>

            }

        </>
        )
}

export default Home;